/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const styles = {
  card: () => css`
    position: relative;
    padding: var(--cds-spacing-300);
    border: 1px solid var(--cds-color-grey-50);
    margin-bottom: var(--cds-spacing-200);
    background-color: var(--cds-color-neutral-background-primary);
    border-radius: 8px;

    ${breakpoints.down('sm')} {
      padding: var(--cds-spacing-300);
      width: 100%;
    }
  `,
};

type PropsFromCaller = {
  // Using the css prop from emotion on a non-html React component overrides the css applied inside the component (see https://emotion.sh/docs/with-props).
  // I want to maintain the styles applied inside this component, so I created a this separate customCss prop.
  customCss?: Interpolation<Theme>;
  ['data-e2e']?: string;
};

type Props = PropsFromCaller & {
  children: React.ReactNode;
};

const ProfileViewerCard = ({ children, customCss, 'data-e2e': e2e }: Props) => {
  return (
    <section css={[styles.card, customCss]} data-e2e={e2e}>
      {children}
    </section>
  );
};

export default ProfileViewerCard;
